import { Component, OnInit, ChangeDetectionStrategy, inject } from "@angular/core";
import { AdminService } from "../../../shared/services/admin.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { empty } from "../../../functions";
import { catchError } from "rxjs/operators";
import { Tag } from "../../../api/models/tag";

@Component({
  selector: "app-modal-admin-tag",
  templateUrl: "./modal-admin-tag.component.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalAdminTagComponent implements OnInit {
  readonly activeModal = inject(NgbActiveModal);
  readonly adminService = inject(AdminService);

  public data!: { entity: Tag };
  entity: Tag = {};

  ngOnInit(): void {
    this.entity = this.data.entity;
  }

  Save() {
    if (!empty(this.entity.id)) {
      this.adminService
        .apiUpdateTag(this.entity)
        .pipe(catchError(this.adminService.handleError("apiUpdateTag", false)))
        .subscribe((result) => {
          if (result !== false) {
            this.activeModal.close(true);
          }
        });
    } else {
      this.adminService
        .apiAddTag(this.entity)
        .pipe(catchError(this.adminService.handleError("apiAddTag", false)))
        .subscribe((result) => {
          if (result !== false) {
            this.activeModal.close(true);
          }
        });
    }
  }
}
